import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecommendationCard = ({ recommendation, onInterested, onNotNow }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleInterested = async () => {
    setIsProcessing(true);
    await onInterested(recommendation.id);
    setIsProcessing(false);
  };

  const handleNotNow = async () => {
    setIsProcessing(true);
    await onNotNow(recommendation.id);
    setIsProcessing(false);
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden shadow-soft hover:shadow-medium transition-shadow flex-shrink-0 w-80">
      <div className="relative h-48">
        <Image
          src={recommendation.image}
          alt={recommendation.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 left-3">
          <div className="bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium">
            {recommendation.category}
          </div>
        </div>
        <div className="absolute top-3 right-3">
          <div className="bg-black/50 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center space-x-1">
            <Icon name="Star" size={12} className="text-yellow-400 fill-current" />
            <span>{recommendation.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-4">
        <div className="mb-3">
          <h4 className="font-heading font-semibold text-foreground mb-1">
            {recommendation.title}
          </h4>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {recommendation.description}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={14} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{recommendation.location}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={14} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{recommendation.duration}</span>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-muted-foreground">Starting from</p>
            <p className="text-lg font-semibold text-primary">
              ₹{recommendation.price.toLocaleString('en-IN')}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Match Score</p>
            <div className="flex items-center space-x-1">
              <div className="w-12 bg-muted rounded-full h-2">
                <div 
                  className="bg-success h-2 rounded-full"
                  style={{ width: `${recommendation.matchScore}%` }}
                />
              </div>
              <span className="text-xs font-medium text-success">
                {recommendation.matchScore}%
              </span>
            </div>
          </div>
        </div>

        <div className="flex space-x-2">
          <Button
            variant="default"
            size="sm"
            onClick={handleInterested}
            loading={isProcessing}
            iconName="Heart"
            iconPosition="left"
            className="flex-1"
          >
            Interested
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={handleNotNow}
            disabled={isProcessing}
            className="flex-1"
          >
            Not Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;